// extracted by mini-css-extract-plugin
export default {"base":"vp_SrRmM","titlebar":"vp_GQAgG","title":"vp_Sc1GK","buttons":"vp_XykmL","content":"vp_OYWUi"};